module.exports = __webpack_public_path__ + "static/media/surpriseBackground.17b6471e.png";